import React from 'react';
import { BookOpenIcon, CheckCircle2Icon, GraduationCapIcon } from 'lucide-react';
const collections = [{
  Icon: GraduationCapIcon,
  label: 'Colección Primaria',
  range: 'Tomos 01 al 06',
  title: 'Planificación anual completa para cada año de 1º a 6º de Primaria.',
  description: 'Una base clara y progresiva para que cada grupo aprenda, disfrute y avance a su ritmo durante todo el ciclo escolar.',
  topics: ['Psicomotricidad', 'Juegos motores', 'Habilidades básicas'],
  accent: 'bg-emerald-600'
}, {
  Icon: BookOpenIcon,
  label: 'Colección Secundaria',
  range: 'Tomos 07 al 12',
  title: 'Planificación anual completa para cada año de 1º a 6º de Secundaria.',
  description: 'Una hoja de ruta preparada para desarrollar autonomía, técnica y hábitos de movimiento en cada etapa adolescente.',
  topics: ['Iniciación deportiva', 'Táctica', 'Condición física y salud'],
  accent: 'bg-sky-700'
}];
export function ModulesSection() {
  return <section className="bg-white px-5 py-20" data-id="element-122" data-mp="1iuyxk0izp5u1">
      <div className="mx-auto max-w-5xl" data-id="element-123" data-mp="1it5pqhwn4fkg">
        <div className="mx-auto max-w-3xl text-center" data-id="element-124" data-mp="1nuldwiu47272">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-emerald-700" data-id="element-125" data-mp="1ns8vk4kg2pth">
            La colección completa
          </p>
          <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-[#09281d] sm:text-5xl" data-id="element-126" data-mp="1dvmdfnji6cv5">
            Dentro de la colección —{' '}
            <span className="text-emerald-700" data-id="element-127" data-mp="102o1apiuc64w">doce tomos completos</span>
          </h2>
        </div>
        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-128" data-mp="14xk8iwwnf02l">
          {collections.map(({
          Icon,
          label,
          range,
          title,
          description,
          topics,
          accent
        }) => <article key={label} className="flex min-h-[350px] flex-col border border-[#E5E5EA] p-7 sm:p-8" data-id="element-129" data-mp="v6ftxyavxh8a">
                <div className="flex items-center gap-3" data-id="element-130" data-mp="l78e94gohai0">
                  <span className={`grid h-12 w-12 place-items-center ${accent}`} data-id="element-131" data-mp="l6ov5kfakg2e">
                    <Icon className="h-6 w-6 text-white" data-id="element-132" data-mp="2nvyhvmdwij7k" />
                  </span>
                  <div data-id="element-133" data-mp="2j1c6vkbqeso0">
                    <p className="text-xs font-bold uppercase tracking-widest text-emerald-700" data-id="element-134" data-mp="2e4c4bje3c81n">
                      {label}
                    </p>
                    <p className="mt-1 text-xs font-semibold text-slate-500" data-id="element-135" data-mp="296u20bukwr2m">
                      {range}
                    </p>
                  </div>
                </div>
                <h3 className="mt-7 text-2xl font-bold leading-tight text-[#0A0A0A]" data-id="element-136" data-mp="31tn6n5b3aahw">
                  {title}
                </h3>
                <p className="mt-4 text-sm font-medium leading-relaxed text-[#5A5A66]" data-id="element-137" data-mp="2wt0iznlzdh4z">
                  {description}
                </p>
                <ul className="mt-auto space-y-3 pt-7" data-id="element-138" data-mp="1lfew693lfrmm">
                  {topics.map(topic => <li key={topic} className="flex items-center gap-2 text-sm font-bold text-[#09281d]" data-id="element-139" data-mp="1hebdzfy2pji8">
                      <CheckCircle2Icon className="h-4 w-4 shrink-0 text-emerald-700" data-id="element-140" data-mp="3szc1jtaizuyg" />
                      {topic}
                    </li>)}
                </ul>
              </article>)}
        </div>
      </div>
    </section>;
}